import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

interface IProps {
  ariaLabel: string;
  img: string;
  imgMobile: string;
  loading: 'eager' | 'lazy';
  width?: string;
  height?: string;
}

const HomeImage = ({ ariaLabel, img, imgMobile, loading, width, height }: IProps): ReactElement => (
  <picture>
    <source data-srcset={imgMobile} media="(max-width: 768px)" srcSet={imgMobile} />
    <img
      loading={loading}
      data-src={img}
      alt={ariaLabel}
      src={img}
      {...(width && { width })}
      {...(height && { height })}
    />
  </picture>
);

export default HomeImage;
